import NotFound from 'views/NotFound';
import Home from 'views/Home';
import StripePage from 'views/StripePage';
import Blog from 'views/Blog';
import BlogPost from 'views/BlogPost';
import Employee from 'views/Employee';
import CategoryPage from 'views/CategoryPage';
import ManualRegistration from 'views/ManualRegistration';
import Page from 'views/Page';

export default [
    { path: '/cms', exact: true, component: () => window.location.replace('/cms/wp-login.php') },

    { path: '/404', exact: true, component: NotFound },

    { path: '/', exact: true, component: Home },

    { path: '/stripe', exact: true, component: StripePage },
    { path: '/blogg/', exact: true, component: Blog },
    { path: '/blogg/:slug', exact: true, component: BlogPost },
    { path: '/ansatte/:slug', exact: true, component: Employee },
    { path: '/fag/:slug', exact: true, component: CategoryPage },
    { path: '/bekreft-plass', exact: true, component: ManualRegistration },
    
    { path: '/:slug', exact: true, component: Page },
    { path: '/:parent/:slug', exact: true, component: Page },
    { path: '/:grandparent/:parent/:slug', exact: true, component: Page },
    
    { path: '/*', exact: false, component: NotFound },
]


// WEBPACK FOOTER //
// ./src/routes.js